import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from '../../shared/services/api.service';
import { Observable } from 'rxjs';
import { ComponentResponse, ComponentsResponse } from '../responses/component.response';
import { Parameter } from '../../shared/models/parameter.model';
import { ComponentModel } from '../models/component.model';
import { environment } from '../../../../environments/environment';
import { ComponentQueryBuilder } from '../../shared/classes/component.query-builder.class';
import { SurveySampleQueryBuilder } from '../../shared/classes/survey_sample.query-builder.class';

@Injectable()
export class ComponentsService {
  private resource = 'components';
  private queryBuilder: ComponentQueryBuilder;

  constructor(private http: HttpClient) {
    if (environment.cordova) {
      this.queryBuilder = new ComponentQueryBuilder();
    }
  }

  /**
   * Get all components.
   */
  getAllComponents(
    limit: number = 15,
    includes: string[] = null,
    sorting: string = null,
    appends: string[] = null,
    parameters: Parameter[] = [],
  ): Observable<ComponentsResponse> {
    let params = new HttpParams();

    params = params.set('limit', limit.toFixed(0));

    if (includes) {
      params = params.set('include', includes.join(','));
    }

    if (appends) {
      params = params.set('append', appends.join(','));
    }

    if (sorting) {
      params = params.set('sort', sorting);
    }

    parameters.forEach(parameter => {
      if (parameter.value) {
        params = params.set(`filter[${parameter.field}]`, `${parameter.value}`);
      }
    });

    return this.http.get<ComponentsResponse>(`${ApiService.ApiUrl}/${this.resource}`, { params });
  }

  /**
   * Find component by id.
   */
  findComponentById(componentId: string, includes: string[] = null): Observable<ComponentResponse> {
    let params = new HttpParams();

    if (includes) {
      params = params.set('include', includes.join(','));
    }

    return !environment.cordova
      ? this.http.get<ComponentResponse>(`${ApiService.ApiUrl}/${this.resource}/${componentId}`, { params })
      : this.queryBuilder.findWithIncludes(+componentId, includes);
  }

  /**
   * Create new user component.
   */
  createComponent(component: ComponentModel): Observable<ComponentResponse> {
    return !environment.cordova
      ? this.http.post<ComponentResponse>(`${ApiService.ApiUrl}/${this.resource}`, component)
      : this.queryBuilder.create(component);
  }

  /**
   * Update user component.
   */
  updateComponent(component: ComponentModel): Observable<ComponentResponse> {
    return !environment.cordova
      ? this.http.patch<ComponentResponse>(`${ApiService.ApiUrl}/${this.resource}/${component.id}`, component)
      : this.queryBuilder.update(component);
  }

  /**
   * Delete user component.
   */
  deleteComponent(component: ComponentModel): Observable<any> {
    if (environment.cordova) {
      this.queryBuilder = new ComponentQueryBuilder();
    }

    return !environment.cordova
      ? this.http.delete(`${ApiService.ApiUrl}/${this.resource}/${component.id}`)
      : this.queryBuilder.where('id', '=', component.id).delete(component);
  }

  /**
   * Sync component.
   */
  syncComponent(payload): Observable<any> {
    return this.http.post<any>(`${ApiService.ApiUrl}/${this.resource}/sync`, payload);
  }
}
